<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockPriorities, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockPriorities;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockPriorities) => void;
  } = $props();

  function edit(index: number, text: string) {
    onchange?.({ ...block, items: block.items.map((it, i) => (i === index ? { ...it, text } : it)) });
  }
  const meta = (owner?: string, date?: string) => [owner, date].filter(Boolean).join(' · ');
</script>

<p class="brf-sub">Priorities</p>
<ol class="brf-prio">
  {#each block.items as item, i (i)}
    <li>
      <b><EditableText value={item.text} {editing} ariaLabel="Priority {i + 1}"
           onchange={(text) => edit(i, text)} /></b
      >{#if meta(item.owner, item.date)}<span class="when">{meta(item.owner, item.date)}</span>{/if}<Provenance
         provenance={item.provenance} sourceIds={item.source_ids} {ctx} />
    </li>
  {/each}
</ol>
